import { Instrument } from "piano-chart";
import "./App.css";
import React, { useEffect, useState, useRef } from "react";
import { WebMidi } from "webmidi";
import { Factory, Flow } from "vexflow";
import MidiPlayer from "midi-player-js";
import { parseMidi } from "midi-file";
import MF from "./chord scale.mid";
import { Chord } from "tonal";

function App() {
  const [sustain, setSustain] = useState(false);
  const sustainRef = useRef(sustain);
  const notesToReleaseRef = useRef(new Set());
  const heldNotesRef = useRef(new Set());
  const [heldNotes, setHeldNotes] = useState([]);
  const [chords, setChords] = useState([]);
  const [visualNotes, setVisualNotes] = useState([]);
  const [player, setPlayer] = useState(null);
  const [globalPiano, setGlobalPiano] = useState(null);
  // // eslint-disable-next-line
  // const [keySpec, setKeySpec] = useState("C");
  const pianoContainerRef = useRef(null);
  const pianoScoreRef = useRef(null);
  // const vfRef = useRef(null);
  // const scoreRef = useRef(null);
  // const trebleStaveRef = useRef(null);
  // const bassStaveRef = useRef(null);
  // const contextRef = useRef(null);
  // eslint-disable-next-line
  // useEffect(() => {
  //   const vf = new Factory({
  //     renderer: {
  //       elementId: pianoScoreRef.current.id,
  //       width: 500,
  //       height: 600,
  //       background: "#ff00ff",
  //     },
  //   });

  //   // const score = vf.EasyScore();
  //   // const context = vf.getContext();
  //   // const trebleStave = vf.Stave({ x: 10, y: 120, width: 200 });
  //   // const bassStave = vf.Stave({ x: 10, y: 180, width: 200 });

  //   // vfRef.current = vf;
  //   // scoreRef.current = score;
  //   // contextRef.current = context;
  //   // trebleStaveRef.current = trebleStave;
  //   // bassStaveRef.current = bassStave;

  //   // trebleStave
  //   //   .addClef("treble")
  //   //   .addTimeSignature("4/4")
  //   //   .addKeySignature(keySpec)
  //   //   .setContext(context)
  //   //   .draw();
  //   // bassStave
  //   //   .addClef("bass")
  //   //   .addTimeSignature("4/4")
  //   //   .addKeySignature(keySpec)
  //   //   .setContext(context)
  //   //   .draw();
  //   // eslint-disable-next-line
  // }, []);
  // eslint-disable-next-line
  // useEffect(() => {
  //   function renderNotes() {
  //     if (
  //       !vfRef.current ||
  //       !scoreRef.current ||
  //       !contextRef.current ||
  //       !trebleStaveRef.current ||
  //       !bassStaveRef.current
  //     )
  //       return;
  //     // eslint-disable-next-line
  //     const vf = vfRef.current;
  //     const score = scoreRef.current;
  //     const context = contextRef.current;
  //     const trebleStave = trebleStaveRef.current;
  //     const bassStave = bassStaveRef.current;

  //     // Clear the context
  //     context.clearRect(0, 0, 500, 600);

  //     // Draw the staves
  //     trebleStave.setContext(context).draw();
  //     bassStave.setContext(context).draw();

  //     // Keep track of all held notes to render them
  //     const allHeldNotes = new Set([
  //       ...heldNotesRef.current,
  //       ...notesToReleaseRef.current,
  //     ]);

  //     // Render notes
  //     const formattedNotes = formatString(Array.from(allHeldNotes));

  //     const [trebleNotes, bassNotes] = formattedNotes.split(",") || [];

  //     if (!trebleNotes || !bassNotes) {
  //       console.error("Invalid note format:", formattedNotes);
  //       return; // Skip invalid note format
  //     }

  //     const voiceTreble = score.voice(score.notes(trebleNotes, { stem: "up" }));
  //     const voiceBass = score.voice(
  //       score.notes(bassNotes, { clef: "bass", stem: "up" }),
  //     );

  //     try {
  //       // Format and draw the voices
  //       new Flow.Formatter()
  //         .joinVoices([voiceTreble])
  //         .format([voiceTreble], 400);
  //       new Flow.Formatter().joinVoices([voiceBass]).format([voiceBass], 400);
  //       voiceTreble.draw(context, trebleStave);
  //       voiceBass.draw(context, bassStave);
  //     } catch (error) {
  //       console.error("Error rendering notes:", error);
  //     }
  //   }

  //   renderNotes();
  // }, [heldNotes, sustain]);
  // eslint-disable-next-line
  // function increaseNumbersByTwo(inputString) {
  //   // Regular expression to match all numbers in the string
  //   const regex = /\d+/g;

  //   // Use replace method with a callback function to increase each matched number by 2
  //   const resultString = inputString.replace(regex, (match) => {
  //     const number = parseInt(match, 10); // Parse the matched number
  //     const increasedNumber = number + 2; // Increase the number by 2
  //     return increasedNumber.toString(); // Convert back to string and return
  //   });

  //   return resultString;
  // }

  // function formatString(notesArray) {
  //   const trebleNotes = [];
  //   const bassNotes = [];

  //   notesArray.forEach((note) => {
  //     if (note.endsWith("4")) {
  //       trebleNotes.push(note);
  //     } else if (note.endsWith("5")) {
  //       trebleNotes.push(note);
  //     } else if (note.endsWith("6")) {
  //       trebleNotes.push(note);
  //     } else if (note.endsWith("7")) {
  //       trebleNotes.push(note);
  //     } else if (note.endsWith("8")) {
  //       trebleNotes.push(note);
  //     } else {
  //       bassNotes.push(note);
  //     }
  //   });

  //   const formattedTreble =
  //     trebleNotes.length >= 2
  //       ? `(${trebleNotes.join(" ")})/1`
  //       : `${trebleNotes}/w`;
  //   const formattedBass =
  //     bassNotes.length >= 2 ? `(${bassNotes.join(" ")})/1` : `${bassNotes}/w`;

  //   return `${trebleNotes.length >= 1 ? formattedTreble : "B4/w/r"},${bassNotes.length >= 1 ? formattedBass : "D3/w/r"}`;
  // }
  //
  //

  function fromFile() {
    if (window.FileReader) {
      var reader = new FileReader();
      var f = document.getElementById("fileItem").files[0];
      reader.onload = function (e) {
        var bytes = new Uint8Array(e.target.result);
        player.loadArrayBuffer(bytes);
      };
      reader.readAsArrayBuffer(f);
    } else console.log("File API is not supported in this browser.");
  }

  useEffect(() => {
    sustainRef.current = sustain;
  }, [sustain]);

  useEffect(() => {
    const piano = new Instrument(document.getElementById("piano-container"), {
      startOctave: 0,
      startNote: "A",
      endOctave: 8,
      endNote: "C",
      keyPressStyle: "vivid",
      showNoteNames: "onpress",
      vividKeyPressColor: "#FF5733",
    });
    piano.create();

    setGlobalPiano(piano);

    WebMidi.enable()
      .then(onEnabled)
      .catch((err) => alert(err));

    var Player = new MidiPlayer.Player(function (event) {
      console.log(event);
      if (event.name === "Note on") {
        piano.keyDown(event.noteName);
        heldNotesRef.current.add(event.noteName);
        updateHeldNotes();
      }
      if (event.name === "Note off") {
        heldNotesRef.current.delete(event.noteName);
        if (sustainRef.current) {
          notesToReleaseRef.current.add(event.noteName);
        } else {
          piano.keyUp(event.noteName);
        }
        updateHeldNotes();
      }
    });

    setPlayer(Player);

    function parseNote(note) {
      // Separate the pitch from the octave
      const match = note.match(/^([A-Ga-g]#?)(\d+)$/);
      if (!match) throw new Error(`Invalid note format: ${note}`);
      const [, pitch, octave] = match;
      return { pitch: pitch.toUpperCase(), octave: parseInt(octave, 10) };
    }

    function compareNotes(note1, note2) {
      const pitches = [
        "C",
        "C#",
        "D",
        "D#",
        "E",
        "F",
        "F#",
        "G",
        "G#",
        "A",
        "A#",
        "B",
      ];

      const parsedNote1 = parseNote(note1);
      const parsedNote2 = parseNote(note2);

      if (parsedNote1.octave !== parsedNote2.octave) {
        return parsedNote1.octave - parsedNote2.octave;
      } else {
        return (
          pitches.indexOf(parsedNote1.pitch) -
          pitches.indexOf(parsedNote2.pitch)
        );
      }
    }

    function sortMusicalNotes(notes) {
      return notes.sort(compareNotes);
    }

    function onEnabled() {
      const myInput = WebMidi.getInputByName("Network Session 1");
      const mySynth = myInput.channels[1]; // <-- the MIDI channel (1)

      mySynth.addListener("noteon", (e) => {
        const note = `${e.note.name}${e.note.accidental ? e.note.accidental : ""}${e.note.octave}`;

        piano.keyDown(note);
        heldNotesRef.current.add(note);
        updateHeldNotes();

        setVisualNotes(sortMusicalNotes(Array.from(heldNotesRef.current)));

        const chords = Chord.detect(
          sortMusicalNotes(Array.from(heldNotesRef.current)),
          { assumePerfectFifth: true },
        );
        setChords(chords);
      });

      mySynth.addListener("noteoff", (e) => {
        const note = `${e.note.name}${e.note.accidental ? e.note.accidental : ""}${e.note.octave}`;

        heldNotesRef.current.delete(note);
        if (sustainRef.current) {
          notesToReleaseRef.current.add(note);
        } else {
          piano.keyUp(note);

          const chords = Chord.detect(
            sortMusicalNotes(Array.from(heldNotesRef.current)),
            { assumePerfectFifth: true },
          );
          setChords(chords);

          setVisualNotes(sortMusicalNotes(Array.from(heldNotesRef.current)));
        }
        updateHeldNotes();
      });

      mySynth.addListener("controlchange-controller64", (e) => {
        if (e.value === 0) {
          // Sustain pedal released
          notesToReleaseRef.current.forEach((note) => {
            if (!heldNotesRef.current.has(note)) {
              const chords = Chord.detect(
                sortMusicalNotes(Array.from(notesToReleaseRef.current)),
                { assumePerfectFifth: true },
              );
              setChords(chords);

              setVisualNotes(
                sortMusicalNotes(Array.from(notesToReleaseRef.current)),
              );

              piano.keyUp(note);
            }
          });
          notesToReleaseRef.current.clear();
          setSustain(false);

          const chords = Chord.detect(
            sortMusicalNotes(Array.from(heldNotesRef.current)),
            { assumePerfectFifth: true },
          );
          setChords(chords);

          setVisualNotes(sortMusicalNotes(Array.from(heldNotesRef.current)));

          // console.log("sustain set to false");
        } else if (e.value === 1) {
          // Sustain pedal pressed
          setSustain(true);
          // console.log("sustain set to true");
        }
      });
    }
  }, []);

  function updateHeldNotes() {
    setHeldNotes(Array.from(heldNotesRef.current));
  }

  function parseChords(chordOption) {
    if (!chordOption) return;

    if (chordOption.includes("M")) {
      if (chordOption.includes("M")) {
        return chordOption.replace("M", " Major ");
      }
    } else return chordOption;
  }

  function changeToFlats(input) {
    if (String(input).includes("#")) {
      if (String(input) === "C#") return `Db`;
      if (String(input) === "D#") return `Eb`;
      if (String(input) === "F#") return `Gb`;
      if (String(input) === "G#") return `Ab`;
      if (String(input) === "A#") return `Bb`;
    } else return input;
  }

  function parseNotes(noteOptions) {
    let temp = [];
    noteOptions.forEach((note) => {
      if (note.includes("#")) {
        temp.push(changeToFlats(`${note.slice(0, 2)}`));
      } else {
        temp.push(`${note.slice(0, 1)}`);
      }
    });

    if (temp.length === 0) {
      temp.push("·");
    }
    return temp;
  }

  return (
    <div className="App">
      {/* <div id="piano-score" ref={pianoScoreRef} className="piano-score"></div> */}
      <input id="fileItem" type="file" onChange={fromFile} />
      <button onClick={() => player.play()}>Play </button>
      <button
        onClick={() => {
          player.stop();
          player.resetTracks();
        }}
      >
        Stop{" "}
      </button>
      <div id="chords" className="chords">
        {parseChords(chords[0]) || "·"}
      </div>
      <div id="letters" className="letters">
        {visualNotes.length === 0 ? (
          <p>·</p>
        ) : (
          parseNotes(visualNotes).map((note) => <p className="notes">{note}</p>)
        )}
      </div>
      <div
        className="piano-overlay"
        id="piano-container"
        ref={pianoContainerRef}
      ></div>
      <div id="sustain" className="sustain">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="150"
          height="150"
          viewBox="0 0 500 499"
          version="1.1"
        >
          <path
            d="M 241 117.624 C 221.872 119.322, 206.310 123.743, 189.760 132.181 C 142.036 156.514, 112.998 208.954, 117.982 261.808 C 122.872 313.667, 156.036 357.264, 204.500 375.547 C 230.019 385.173, 264.639 385.884, 291.500 377.334 C 319.351 368.468, 344.883 349.035, 361.525 324.036 C 391.648 278.788, 391.360 222.530, 360.766 175.500 C 342.772 147.841, 307.259 124.765, 274.686 119.568 C 264.585 117.956, 248.026 117, 241 117.624 M 235.500 131.074 C 208.999 134.712, 183.409 147.546, 165.389 166.237 C 151.202 180.951, 143.513 193.195, 137.173 211.166 C 126.735 240.753, 128.045 269.763, 141.175 299.763 C 154.025 329.124, 180.935 353.652, 211.732 364.075 C 225.944 368.885, 235.213 370.400, 250.500 370.413 C 266.326 370.427, 275.210 368.918, 291.091 363.517 C 325.896 351.681, 353.943 322.395, 365.495 285.826 C 374.402 257.630, 372.299 227.654, 359.431 199.418 C 355.451 190.684, 347.159 177.784, 345.990 178.506 C 345.569 178.766, 344.249 182.696, 343.056 187.240 C 339.360 201.320, 325.777 247.461, 325.106 248.215 C 324.613 248.770, 251.346 228.540, 250.236 227.542 C 250.090 227.411, 250.860 224.423, 251.946 220.902 C 253.033 217.381, 255.473 208.875, 257.369 202 C 259.265 195.125, 264.448 176.928, 268.887 161.562 C 273.326 146.197, 276.821 133.488, 276.653 133.320 C 274.481 131.148, 246.201 129.604, 235.500 131.074 M 246 242.361 C 242.975 245.806, 238.475 250.036, 236 251.761 C 227.617 257.604, 225.024 258.208, 204.500 259.095 C 179.697 260.166, 175.620 260.643, 170.959 263.021 C 166.256 265.420, 164.784 267.898, 165.192 272.730 C 165.457 275.861, 166.134 276.746, 170 279.011 C 177.529 283.421, 194.254 289.843, 206.194 292.908 C 226.741 298.183, 244.527 299.259, 263.720 296.387 C 278.116 294.233, 292.806 295.283, 309.764 299.680 C 313.210 300.574, 316.257 301.076, 316.536 300.797 C 317.919 299.415, 319.967 285.448, 319.983 277.299 C 319.996 269.962, 318.618 258.510, 317.572 257.274 C 317.467 257.149, 314.933 257.992, 311.940 259.146 C 304.543 261.999, 292.594 262.059, 284.905 259.282 C 277.956 256.771, 262.985 246.734, 257.042 240.601 C 254.590 238.070, 252.340 236.022, 252.042 236.048 C 251.744 236.075, 249.025 238.915, 246 242.361 M 161.750 281.080 C 160.787 281.641, 160 282.907, 160 283.895 C 160 286.257, 162.145 288.067, 170 292.331 C 190.915 303.684, 229.731 311.589, 252.238 309.080 C 257.498 308.493, 262.464 307.759, 263.273 307.449 C 264.369 307.028, 264.635 307.474, 264.316 309.192 C 263.904 311.405, 264.800 311.754, 286.154 317.706 C 298.401 321.120, 308.541 323.792, 308.688 323.645 C 309.762 322.572, 313.909 305.509, 313.255 304.855 C 311.634 303.234, 296.540 299.992, 285.307 298.853 C 275.461 297.855, 272.095 297.942, 260.813 299.488 C 231.360 303.522, 199.182 297.935, 172.369 284.129 C 163.372 279.497, 164.106 279.708, 161.750 281.080 M 149.223 297.557 C 146.526 299.445, 146.327 303.327, 148.799 305.799 C 149.967 306.967, 160.680 310.149, 179.356 314.876 C 206.621 321.778, 208.241 322.072, 210.557 320.555 C 213.796 318.433, 213.899 313.633, 210.750 311.576 C 208.836 310.326, 155.174 296, 152.405 296 C 151.877 296, 150.445 296.701, 149.223 297.557"
            stroke="none"
            className="sustain"
            fill={sustain ? "#FF5733" : "#000"} // Dynamic fill color
            fillRule="evenodd"
          />
        </svg>
        <p className="words">{sustain ? "SUSTAIN DOWN" : "SUSTAIN UP"}</p>
      </div>
    </div>
  );
}

export default App;
